export const styles = {
  denseList: {
    pb: 1,
    "& .MuiListItem-root": {
      py: 0,
    },
  },
};
